export default __webpack_public_path__ + "static/media/macosx.c13244b1.svg";